import React from "react";
import { UncompletedData } from "../pages/UncompletedChecklists";
import UncompletedChecklistCard from "./UncompletedChecklistCard";
import { Moment } from "moment";

interface UnitcompletedChecklistListProps {
    weekDate: Moment|null,
    uncompletedChecklists: UncompletedData[];
    onNoteSaved: () => void;
}

const UnitcompletedChecklistList: React.FC<UnitcompletedChecklistListProps> = ({ weekDate, uncompletedChecklists, onNoteSaved }) => {
    return (
        <div>
            <div className="unit-bg shadow-lg px-2 py-3 rounded-lg border border-[#F5F5F5] mt-3 h-home overflow-y-scroll">
                <div>
                    {uncompletedChecklists.map((uncompletedData, index) => {
                        return <div key={index}>
                            <UncompletedChecklistCard 
                                unit={uncompletedData.unit} 
                                weeklyNote={uncompletedData.weeklyNote} 
                                weekDate={weekDate}
                                onNoteSaved={onNoteSaved}
                            />
                        </div>
                    })}
                </div>
            </div>
        </div>
    );
}

export default UnitcompletedChecklistList;